import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShieldCheck, ShieldAlert, Loader2 } from "lucide-react";

export default function ConsensusPill() {
  const [st, setSt] = useState(null);

  useEffect(() => { api.get("/consensus/status").then(r => setSt(r.data)).catch(() => {}); }, []);
  if (!st) return null;

  const stale = st.status === "stale";
  const pending = st.status === "pending";
  const label = stale ? "Values Frozen (stale)" : pending ? "Verifying…" : "Market-Verified";
  const color = stale ? "var(--amber)" : pending ? "var(--text-3)" : "var(--accent)";
  const Icon = stale ? ShieldAlert : ShieldCheck;

  return (
    <div
      className="inline-flex items-center gap-2 border border-[var(--border)] bg-black/40 rounded-sm px-3 py-1.5 text-xs"
      data-testid="consensus-pill"
      title="Dynasty Metrics' proprietary valuation — every asset continuously re-priced and market-verified."
      style={{ color }}
    >
      {pending ? <Loader2 className="w-3.5 h-3.5 spin" /> : <Icon className="w-3.5 h-3.5" />}
      <span className="font-mono tracking-wide">DATABASE STATUS: <span className="font-semibold">{label}</span></span>
    </div>
  );
}
